import React from 'react'
import { PartnerService } from '@duck/api-definitions'
import { cn } from '@duck/ui'
import { useTar } from '@/modules/i18n'

const S = PartnerService.AssignmentDetailsStatus

interface StatusPillProps {
  status?: PartnerService.AssignmentDetailsStatus
  /** Submitted but feedback not yet available → show a processing pill instead. */
  processing?: boolean
}

export const StatusPill: React.FC<StatusPillProps> = ({ status, processing }) => {
  const { t } = useTar()
  if (processing) {
    return (
      <span className="inline-flex items-center rounded-full border border-border bg-muted/40 px-2.5 py-0.5 text-xs italic text-muted-foreground">
        {t('challenges.feedbackProcessing')}…
      </span>
    )
  }
  // Intentional redesign status language (Sent=muted, Started=blue, Submitted=success).
  // Deliberately distinct from the legacy cohortPeopleTable.utils palette — do not reconcile the two.
  const map: Partial<Record<PartnerService.AssignmentDetailsStatus, { label: string; cls: string }>> = {
    [S.Sent]: { label: t('common.sent'), cls: 'border-border bg-muted/40 text-muted-foreground' },
    [S.Started]: { label: t('common.started'), cls: 'border-blue-500/40 bg-blue-500/10 text-blue-500 dark:text-blue-400' },
    [S.Submitted]: { label: t('common.submitted'), cls: 'border-success/40 bg-success/10 text-success' },
    [S.Forfeited]: { label: t('common.forfeited'), cls: 'border-border bg-muted/30 text-muted-foreground' },
  }
  const entry = status ? map[status] : undefined
  if (!entry) return null
  return (
    <span className={cn('inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs', entry.cls)}>
      {entry.label}
    </span>
  )
}
